import * as React from "react";
import { ExtraIconPro } from "../../../services/product";
import { LeftBottomTag, LeftTopTags, NewRightTopTag } from "./styles";

interface ProductImageTagViewsProps {
  columnNum: number;
  rightTopTag?: ExtraIconPro;
  leftTopTag?: ExtraIconPro;
  leftBottomTag?: ExtraIconPro;
  isOnlyShowLeftTopTag?: boolean;
}

export const ProductImageTagViews = (props: ProductImageTagViewsProps) => {
  const { rightTopTag, leftTopTag, leftBottomTag, isOnlyShowLeftTopTag } =
    props;

  const renderTags = () => {
    if (!isOnlyShowLeftTopTag) {
      return (
        <>
          {rightTopTag?.img && <NewRightTopTag src={rightTopTag?.img} alt="" />}
          {leftTopTag?.img && (
            <LeftTopTags>
              {leftTopTag?.img && <img src={leftTopTag.img} alt="" />}
            </LeftTopTags>
          )}
        </>
      );
    } else {
      return (
        <>
          {leftTopTag && leftTopTag.img && (
            <LeftTopTags>
              <img src={leftTopTag.img} alt="" />
            </LeftTopTags>
          )}
        </>
      );
    }
  };

  return (
    <div>
      {renderTags()}
      {leftBottomTag?.img && <LeftBottomTag src={leftBottomTag?.img} alt="" />}
    </div>
  );
};
